<template>
    <div class="pagination"  >
  
      <!-- 分页操作按钮 -->
      <li @click="prevPage"><span>上一页</span></li>
      <li><span   v-for="page in pageCount" :key="page" @click="goToPage(page)">
        {{ page }}
      </span></li>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <li @click="nextPage"><span>下一页</span></li>
       <!-- 分页数据显示 -->
      <span  style=" display:inline-block;   margin:  8px auto">共 {{ total }} 条数据,</span>
      <span  style=" display: inline-block;  margin:   8px auto">当前第 {{ currentPage }} 页</span>
  
</div>  
  </template>
  <script>
  export default {
    props: {
      currentPage: {
        type: Number,
        required: true
      },
      pageSize: {
        type: Number,
        default: 1
      },
      total: {
        type: Number,
        required: true
      }
    },
    computed: {
      pageCount() {
        return Math.ceil(this.total / this.pageSize);
      }
    },
    methods: {
      goToPage(page) {
        this.$emit('page-changed', page);
      },
      prevPage() {
        if (this.currentPage > 1) {
          this.$emit('page-changed', this.currentPage - 1);
        }
      },
      nextPage() {
        if (this.currentPage < this.pageCount) {
          this.$emit('page-changed', this.currentPage + 1);
        }
      }
    }
  };
  </script>